.container {
    width: 100%;
    padding: 1.25rem;
    background-color: var(--static-background-standard);
    border-radius: 12px;
}

.loadingContainer {
    padding: 1.25rem;
    width: 100%;
    background-color: var(--static-background-standard);
    border-radius: 12px;
    height: 100%;
}

.title {
    font-size: var(--font-size-small);
    font-weight: 500;
    color: var(--static-text-standard);
    margin-bottom: 1rem;
}

.chartContainer {
    position: relative;
    width: 100%;
}

.percentageText {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.5rem;
    font-weight: 600;
}